import { Outlet, useLocation } from "react-router-dom";
import RegisterSelectionLeftPanel from "../components/authentication/RegisterSelectionLeftPanel";

const AuthenticationLayout = () => {
  const location = useLocation();
  const isRegisterSelection = location.pathname === "/register";

  return (
    <section className="relative min-h-screen w-full bg-gray-50">
      {/* Previous centered layout kept for reference */}
      {/**
       * <section className="relative flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
       *   <div className="absolute inset-0">
       *     <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] opacity-30"></div>
       *   </div>
       *   <div className="relative z-10 w-full">
       *     <Outlet />
       *   </div>
       * </section>
       */}

      {/* Two-column full-height container */}
      <div className="grid min-h-screen grid-rows-[auto_1fr_auto] md:grid-rows-1 md:grid-cols-12">
        {/* Left branding panel (narrower) */}
        <aside className="order-2 bg-[#0B1731] text-white px-6 py-10 md:order-1 md:col-span-5 md:px-10 md:py-12 flex flex-col">
          {isRegisterSelection ? (
            <RegisterSelectionLeftPanel />
          ) : (
            <div className="mx-auto w-full max-w-sm md:max-w-none">
              {/* Logo - aligned to the same inner container as title/subtitle */}
              <div className="flex items-center gap-3 max-w-lg px-2 md:px-6">
                <img src="/ctb_logo_1.png" alt="Capture The Bug" className="h-12 w-auto md:h-14" />
                <span className="sr-only">Capture The Bug</span>
              </div>

              <div className="mt-10 max-w-lg px-2 md:px-6">
                <h1 className="text-2xl md:text-2xl font-medium leading-snug text-[#58CC02]">
                  Secure your business. Stay audit-ready.
                </h1>
                <p className="mt-4 text-[14px] text-gray-300">
                  Continuous CREST-certified penetration testing across web, mobile, API, and cloud - built for startups and enterprises preparing for SOC 2, ISO 27001, and HIPAA.
                </p>
                {/* Thin divider below subtitle */}
                <div className="mt-10 h-px w-full bg-blue-500/40"></div>
              </div>

              {/* Bullets - share the same inner container width/padding */}
              <div className="mt-10 space-y-6 max-w-lg px-2 md:px-6">
                <div className="flex items-start gap-3">
                  <img src="/icons/CheckCircleFilled.svg" alt="Checked" className="mt-0.5 h-6 w-6 md:h-7 md:w-7" />
                  <div>
                    <p className="font-medium text-[#58CC02] text-lg md:text-lg mb-1.5">Complete visibility into your attack surface</p>
                    <p className="text-sm text-gray-300">
                      CREST-aligned testing across web, mobile, API, and cloud - mapped to real-world attacker techniques.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <img src="/icons/CheckCircleFilled.svg" alt="Checked" className="mt-0.5 h-6 w-6 md:h-7 md:w-7" />
                  <div>
                    <p className="font-medium text-[#58CC02] text-lg md:text-lg mb-1.5">Findings you can trust - and defend in audits</p>
                    <p className="text-sm text-gray-300">
                      Certified security engineers validate, interpret, and support findings so there are no surprises during reviews.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <img src="/icons/CheckCircleFilled.svg" alt="Checked" className="mt-0.5 h-6 w-6 md:h-7 md:w-7" />
                  <div>
                    <p className="font-medium text-[#58CC02] text-lg md:text-lg mb-1.5">Reports built for regulators, not just engineers</p>
                    <p className="text-sm text-gray-300">
                      Audit-friendly outputs mapped to SOC 2, ISO 27001, and HIPAA, with clear remediation guidance and live status tracking.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          )}
        </aside>

        {/* Right form panel (wider) */}
        <main className="order-1 flex items-center justify-center px-6 py-10 md:order-2 md:col-span-7 md:px-6 q md:py-12">
          <div className="w-full max-w-4xl">
            {location.pathname === "/login" && (
              <div className="mb-8 ml-2">
                <h2 className="text-sm font-medium uppercase tracking-wider text-[#58CC02]">
                  Welcome back
                </h2>
                <p className="mt-1 text-lg text-gray-600">
                  Sign in to your Capture The Bug account
                </p>
              </div>
            )}
            <Outlet />
          </div>
        </main>
      </div>
    </section>
  );
};

export default AuthenticationLayout;
